import calculation from './calculation'

export default [...calculation]
